// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.devices-header {
  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 20px;
  font-weight: 600;
  color: #000000;
  flex: 1;
  text-align: center;
  line-height: 1.2;
  margin: 0;
}

.devices-page-content {
  display: flex;
  flex-direction: column;
  gap: 0;
  padding: 0;
}

.devices-header-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 22px;
}

.devices-refresh-button {
  background: none;
  border: none;
  padding: 8px;
  border-radius: 6px;
  cursor: pointer;
  color: #6b7280;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.devices-refresh-button:hover {
  background-color: #f3f4f6;
  color: #374151;
}

.devices-refresh-button ion-icon {
  font-size: 1.25rem;
}

.devices-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.device-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.device-browser {
  font-size: 1rem;
  font-weight: bold;
  color: #374151;
}

.device-divider {
  border: none;
  height: 1px;
  background-color: #e5e7eb;
  margin: 4px 0;
}

.device-info {
  font-size: 0.875rem;
  color: #6b7280;
}`, "",{"version":3,"sources":["webpack://./src/components/SettingsModal/Devices/DevicesPage.css"],"names":[],"mappings":"AAAA;EACE,4EAA4E;EAC5E,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,OAAO;EACP,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB","sourcesContent":[".devices-header {\n  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, sans-serif;\n  font-size: 20px;\n  font-weight: 600;\n  color: #000000;\n  flex: 1;\n  text-align: center;\n  line-height: 1.2;\n  margin: 0;\n}\n\n.devices-page-content {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  padding: 0;\n}\n\n.devices-header-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 14px 22px;\n}\n\n.devices-refresh-button {\n  background: none;\n  border: none;\n  padding: 8px;\n  border-radius: 6px;\n  cursor: pointer;\n  color: #6b7280;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.devices-refresh-button:hover {\n  background-color: #f3f4f6;\n  color: #374151;\n}\n\n.devices-refresh-button ion-icon {\n  font-size: 1.25rem;\n}\n\n.devices-list {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.device-item {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.device-browser {\n  font-size: 1rem;\n  font-weight: bold;\n  color: #374151;\n}\n\n.device-divider {\n  border: none;\n  height: 1px;\n  background-color: #e5e7eb;\n  margin: 4px 0;\n}\n\n.device-info {\n  font-size: 0.875rem;\n  color: #6b7280;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
